import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DataService} from 'src/app/services/data.service';
// Rxjs
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';

@Component({
  selector: 'app-enterprise-insights',
  templateUrl: './enterprise-insights.component.html',
  styleUrls: ['./enterprise-insights.component.scss'],
})
export class EnterpriseInsightsComponent implements OnInit {
  // TODO Rename to INSIGHT Chart
  private params: Params;
  datasetId = 0;
  dataset: any = false;
  isReady = false;
  devMode = false;
  datasetName = '';
  elements: any = [];
  meta: any = {
    total: 0,
    nb_page: 1,
    current_page: 1,
    first_page: 1,
    last_page: 1,
    count: 0,
    per_page: 20,
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private trustiiService: TrustiiService,
    private dataservice: DataService
  ) {}

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit(): void {
    this.devMode = !environment.production;
    this._loadParams$()
      .pipe(
        switchMap(this._loadDataset$.bind(this)),
        tap(this.getInsights.bind(this))
      )
      .subscribe();
  }

  /** _loadParams$ method
   *
   * Load params and set class properties.
   * @return Observable<Params>
   */
  private _loadParams$(): Observable<Params> {
    return this.route.params.pipe(
      map((params: Params) => (this.params = params))
    );
  }

  /** _loadDataset$ method
   *
   * Load dataset if there is id dataset on params.
   */
  private _loadDataset$(): Observable<any> {
    if (!this.params.datasetId || this.params.datasetId <= 0) {
      return of({});
    }
    this.datasetId = this.params.datasetId;
    return this.trustiiService.getDataset(this.datasetId).pipe(
      map((dataset: any) => (this.dataset = dataset.data)),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  /**
   * Get Insights
   */
  getInsights(): void {
    this.trustiiService
      .getInsights(this.datasetName, 0, this.meta.page, this.meta.per_page)
      .subscribe(
        (res) => {
          if (this.dataservice.data.modelId) {
            this.elements = res.data.filter(
              (item) => item.mlModelId === this.dataservice.data.modelId
            );
          } else {
            this.elements = res.data;
          }
          this.meta = res.meta;
          this.meta.total = this.elements.length; // hack for now until we start filter data by modelId
          this.isReady = true;
        },
        (err) => {
          this.isReady = true;
          this.elements = [];
        }
      );
  }

  /**
   * Show insight details
   *
   * @param insightId Insight ID
   * @return void
   */
  getInsightDetails(insightId: number): void {
    this.trustiiService.getInsightDetails(insightId).subscribe(
      (res) => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getInsightDetails(insightId);
          }, 3 * 1000); // poll every 3 seconds
        } else {
          this.dataservice.data = {
            id: res.data.datasetId,
            modelId: res.data.mlModelId,
            insightId,
          };
          this.router.navigateByUrl('enterprise/insights/' + insightId);
        }
      },
      (err) => {}
    );
  }

  /**
   * When limit changed
   *
   * @param perPage Nb result per page
   * @return void
   */
  onLimitChanged(perPage: number): void {
    this.meta.per_page = perPage;
    this.getInsights();
  }

  /**
   * When page changed
   *
   * @param page The page
   * @return void
   */
  onPageChanged(page: number): void {
    this.meta.page = page;
    this.getInsights();
  }

  /**
   * Format date
   *
   * @param stringDate The date
   * @return Local date
   */
  formatDate(stringDate: string): string {
    const date = new Date(stringDate);
    return date.toLocaleString();
  }

  /**
   * Back to models
   *
   * @param datasetId Dataset ID
   */
  backToModels() {
    const datasetId = this.dataservice.data.trainigData;
    this.router.navigateByUrl('enterprise/datasets/' + datasetId + '/mlmodels');
  }

}
